<div class="container">
  <app-template [title]="'Result Template'">
    <mat-tab-group>
      <mat-tab label="Result">
        <form [formGroup]="templateForm" (ngSubmit)="onSubmit($event)">
          <div class="form">
                <span class="input">
                  <button (click)="togle()" type="button" style="margin-top: 10px; margin-right: 100px;" mat-raised-button color="primary">
                    Item Of Service
                  </button>
                  <div class="mobile" *ngIf="isVisible" [@simpleFadeAnimation]="'in'">
                    <div class="mobile_nav">
                      <div class="service">
                        <table style="width:100%">
                          <tr  class="back">
                            <th>
                              <input type="text" class="form-control" id="search-text" aria-describedby="search-text"
                                [(ngModel)]="searchText" placeholder="Search items"
                                autofocus
                                [ngModelOptions]="{standalone: true}"
                              >
                            </th>
                            <th>Price</th>
                          </tr>
                          <tr *ngFor="let item of filteredItems" (click)="setitem(item)" style="cursor: pointer;">
                            <td>{{item.name}}</td>
                            <td>{{item.service_price}}</td>
                          </tr>
                        </table>
                        <div *ngIf="isLoading" class="spinner" style="margin-top: 40px;">
                          <mat-spinner></mat-spinner>
                        </div>
                        <div class="errorMessage">
                          <div *ngIf="Errors" class="error">
                              <p>{{Errors}}</p>
                          </div>
                      </div>
                    </div>
                  </div>
                  </div>
                </span>
                <div style="margin-left: 30px;" class="name">
                  {{itemSelected}}
                </div>
                <span class="input">
                  <mat-form-field>
                      <mat-label>Subject</mat-label>
                      <input formControlName="Name" matInput placeholder="">
                    </mat-form-field>
                </span>
                <div class="space"></div>
              <!-- <quill-editor formControlName="Template_Text" [styles]="{height: '300px'}"></quill-editor> -->
              <angular-editor [config]="editorConfig" [placeholder]="'Enter text here...'" formControlName="Template_Text"></angular-editor>
              <div class="errorMessage">
                  <div *ngIf="Errors" class="error">
                      <p>{{Errors}}</p>
                  </div>
              </div>
              <button type="submit" class="create" *ngIf="!isLoading" mat-raised-button color="primary"> Send</button>
              <button class="create" *ngIf="isLoading" mat-raised-button color="primary"> <i class="fa fa-spinner fa-spin" aria-hidden="true"></i></button>
              <div class="space"></div>
          </div>

      </form>
      </mat-tab>
      <mat-tab label="Edit Template">
        <form [formGroup]="Form" (ngSubmit)="Submit($event)">
          <div class="form">
                <span class="input">
                  <button (click)="togle()" type="button" style="margin-top: 10px; margin-right: 100px;" mat-raised-button color="primary">
                    Item Of Service
                  </button>
                  <div class="mobile" *ngIf="isVisible" [@simpleFadeAnimation]="'in'">
                    <div class="mobile_nav">
                      <div class="service">
                        <table style="width:100%">
                          <tr  class="back">
                            <th>
                              <input type="text" class="form-control" id="search-text" aria-describedby="search-text"
                                [(ngModel)]="searchText" placeholder="Search items"
                                autofocus
                                [ngModelOptions]="{standalone: true}"
                              >
                            </th>
                            <th>Price</th>
                          </tr>
                          <tr *ngFor="let item of filteredItems" (click)="getResultTemplate(item.id)" style="cursor: pointer;">
                            <td>{{item.name}}</td>
                            <td>{{item.service_price}}</td>
                          </tr>
                        </table>
                        <div *ngIf="isLoading" class="spinner" style="margin-top: 40px;">
                          <mat-spinner></mat-spinner>
                        </div>
                        <div class="errorMessage">
                          <div *ngIf="Errors" class="error">
                              <p>{{Errors}}</p>
                          </div>
                      </div>
                    </div>
                  </div>
                  </div>
                </span>
                <span class="input">
                  <mat-form-field>
                      <mat-label>Subject</mat-label>
                      <input formControlName="Name" matInput placeholder="">
                    </mat-form-field>
                </span>
                <div class="space"></div>
              <!-- <quill-editor formControlName="Template_Text" [styles]="{height: '300px'}"></quill-editor> -->
              <angular-editor [config]="editorConfig" [placeholder]="'Enter text here...'" formControlName="Template_Text"></angular-editor>
              <div class="errorMessage">
                  <div *ngIf="Errors" class="error">
                      <p>{{Errors}}</p>
                  </div>
              </div>
              <button type="submit" class="create" *ngIf="!isLoading" mat-raised-button color="primary"> Send</button>
              <button class="create" *ngIf="isLoading" mat-raised-button color="primary"> <i class="fa fa-spinner fa-spin" aria-hidden="true"></i></button>
              <div class="space"></div>
          </div>

      </form>
      </mat-tab>
    </mat-tab-group>
  </app-template>
</div>
<!-- <table>
<tbody>
<tr>
<td>jlyfoujl</td>
<td>ljhvlj</td>
<td>ljkvhl</td>
<td>lkhvl</td>
</tr>
<tr>
<td>jlyfoujl</td>
<td>ljhvlj</td>
<td>ljkvhl</td>
<td>lkhvl</td>
</tr>
<tr>
<td>jlyfoujl</td>
<td>ljhvlj</td>
<td>ljkvhl</td>
<td>lkhvl</td>
</tr>
<tr>
<td>jlyfoujl</td>
<td>ljhvlj</td>
<td>ljkvhl</td>
<td>lkhvl</td>
</tr>
</tbody>
</table> -->
